import { Shadow } from '../../utils/editorReactIcons';
export { Shadow };
export default Shadow;
